import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          {/* Column 1 - Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/fa77cf8cc3bbd77c4d454e1d51d6ad11/0a63fa4771cac11da61baf62adfa212d.png" 
                alt="FluxByte AI" 
                className="h-5 w-auto object-cover"
                style={{ objectFit: 'cover', objectPosition: 'center', transform: 'scale(1.5)' }}
              />
              <span className="text-lg font-bold">FluxByte</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Intelligent AI solutions for modern businesses. Scalable, adaptive, future-ready.
            </p>
            <div className="flex gap-4">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-github-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Column 2 - Newsletter */}
          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 font-semibold mb-4">
              Stay Updated
            </h4>
            <form 
              id="newsletter_form"
              data-readdy-form
              action="https://readdy.ai/api/form/d51e2utmdo3ncn62he60"
              method="POST"
              className="mb-3"
              onSubmit={(e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const email = formData.get('newsletter_email') as string;

                if (!email) {
                  alert('Please enter your email');
                  return;
                }

                fetch('https://readdy.ai/api/form/d51e2utmdo3ncn62he60', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: new URLSearchParams(formData as any).toString()
                })
                .then(response => {
                  if (response.ok) {
                    alert('Thank you for subscribing!');
                    form.reset();
                  } else {
                    alert('Something went wrong. Please try again.');
                  }
                })
                .catch(() => {
                  alert('Something went wrong. Please try again.');
                });
              }}
            >
              <div className="relative">
                <input
                  type="email"
                  name="newsletter_email"
                  required
                  placeholder="Your email"
                  className="w-full bg-transparent border-b border-gray-600/50 py-2 pr-10 text-white placeholder-gray-500 focus:outline-none focus:border-orange-400 transition-colors text-sm"
                />
                <button 
                  type="submit"
                  className="absolute right-0 top-1/2 -translate-y-1/2 text-orange-400 hover:text-orange-300 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
              </div>
            </form>
            <p className="text-gray-500 text-xs">
              Get AI insights &amp; updates. <Link to="/privacy" className="text-gray-400 hover:underline cursor-pointer">Privacy</Link>
            </p>
          </div>

          {/* Column 3 - Solutions */}
          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 font-semibold mb-4">
              Solutions
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/solutions/machine-learning"
                  className="text-white text-sm hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Machine Learning
                </Link>
              </li>
              <li>
                <Link 
                  to="/solutions/ai-automation"
                  className="text-white text-sm hover:text-orange-400 transition-colors cursor-pointer"
                >
                  AI Automation
                </Link>
              </li>
              <li>
                <Link 
                  to="/solutions/data-intelligence"
                  className="text-white text-sm hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Data Intelligence
                </Link>
              </li>
              <li>
                <Link 
                  to="/solutions/custom-development"
                  className="text-white text-sm hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Custom Development
                </Link>
              </li>
              <li>
                <Link 
                  to="/solutions/ai-integration"
                  className="text-white text-sm hover:text-orange-400 transition-colors cursor-pointer"
                >
                  AI Integration
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Company */}
          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 font-semibold mb-4">
              Company
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-white text-sm hover:text-orange-400 transition-colors cursor-pointer">
                  About FluxByte
                </Link>
              </li>
              <li>
                <Link to="/use-cases" className="text-white text-sm hover:text-orange-400 transition-colors cursor-pointer">
                  Use Cases
                </Link>
              </li>
              <li>
                <Link to="/case-studies" className="text-white text-sm hover:text-orange-400 transition-colors cursor-pointer">
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-white text-sm hover:text-orange-400 transition-colors cursor-pointer">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white text-sm hover:text-orange-400 transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500">
          <div>
            © 2025 FluxByte Ltd. UK Registered Company. All rights reserved.
          </div>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-gray-400 transition-colors cursor-pointer">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-gray-400 transition-colors cursor-pointer">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
